export default __webpack_public_path__ + "static/media/fb.fa0859ea.svg";